import { documentationActions } from '../../actions/constant';

const {
 ADD_SIGN_ON_BEHALF_REQUEST,
  ADD_SIGN_ON_BEHALF_SUCCESS,
  ADD_SIGN_ON_BEHALF_FAILURE,
  ADD_SIGN_ON_BEHALF_LOADING,
  ADD_SIGN_ON_BEHALF_RESET,
} = documentationActions;

const intitialstate: object = {
  response: null,
  isSignOnBehalf: false,
  loading: false,
};

export const addSignOnBehalfReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case ADD_SIGN_ON_BEHALF_SUCCESS: {
      return {
        ...state,
        isSignOnBehalf: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case ADD_SIGN_ON_BEHALF_FAILURE:
      return {
        ...state,
        isSignOnBehalf: false,
        response: action.payload,
        loading: false,
      };

    case ADD_SIGN_ON_BEHALF_LOADING:
      return {
        ...state,
        loading: true,
      };

    case ADD_SIGN_ON_BEHALF_RESET:
      return intitialstate;

    default:
      return state;
  }
};
